import React, { useContext } from 'react'
import { CarOrderingContext } from "../../CarOrdering";
import SecurityDeposit from "../Misc/SecurityDeposit";
import TotalPrice from "../Misc/TotalPrice";

export default function FooterPrice() {
  const {
    displaySecurityDeposit,
    strings,
  } = useContext(CarOrderingContext)

  return (
    <div className='config-overview-bar__price_field'>
      <div className='config-overview-bar__field-title'>
        <TotalPrice/>
      </div>
      <div className='config-overview-bar__field-text'>
        {
          ! displaySecurityDeposit &&
          typeof strings.navigation.security_deposit_text === 'string' &&
          strings.navigation.security_deposit_text.length > 0 && (
            <span>{strings.navigation.security_deposit_text}</span>
          )
        }

        {
          displaySecurityDeposit && (
            <>
              <SecurityDeposit/>
              &nbsp;
              <span>{strings.footer.inSecurityDeposit}</span>
            </>
          )
        }
      </div>
    </div>
  )
}
